import { render, staticRenderFns } from "./SuggestList.vue?vue&type=template&id=61e3aee2&scoped=true&"
import script from "./SuggestList.vue?vue&type=script&lang=js&"
export * from "./SuggestList.vue?vue&type=script&lang=js&"
import style0 from "./SuggestList.vue?vue&type=style&index=0&id=61e3aee2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e3aee2",
  null
  
)

export default component.exports